export default "__VITE_ASSET__E1N2hpnF__"